import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

import { DataConventionsService } from 'src/app/services/data-conventions.service';
import {
  DataConvention,
  dimensionOrderLabel,
} from 'src/app/models/organizations/data-convention';
import { OrganizationDataConvention } from 'src/app/models/organizations/organization-data-convention';
import {
  DataConventionSaveDialogComponent,
  DataConventionSaveDialogData,
} from 'src/app/components/home/data-conventions/data-convention-save-dialog/data-convention-save-dialog.component';

@Component({
  selector: 'app-organization-data-convention-section',
  templateUrl: './organization-data-convention-section.component.html',
  styleUrls: ['./organization-data-convention-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class OrganizationDataConventionSectionComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) organizationId!: string;

  private readonly destroy$ = new Subject<void>();
  currentDataConvention: DataConvention | null = null;
  hasPriorConvention: boolean = false;
  readonly dimensionOrderLabel = dimensionOrderLabel;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationId'] && this.organizationId) {
      this.loadLatestDataConvention();
    }
  }

  loadLatestDataConvention(): void {
    this.dataConventionsService
      .getLatestDataConvention(this.organizationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((convention: DataConvention | null) => {
        this.currentDataConvention = convention;
        this.hasPriorConvention = convention !== null;
      });
  }

  openDataConventionDialog(): void {
    this.dialog
      .open(DataConventionSaveDialogComponent, { data: this.buildDialogData() })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: OrganizationDataConvention | undefined) => this.onDialogClosed(result));
  }

  private buildDialogData(): DataConventionSaveDialogData {
    return {
      organizationId: this.organizationId,
      current: this.currentDataConvention,
      hasPriorConvention: this.hasPriorConvention,
    };
  }

  private onDialogClosed(result: OrganizationDataConvention | undefined): void {
    if (result) {
      this.loadLatestDataConvention();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private dataConventionsService: DataConventionsService,
    private dialog: MatDialog,
  ) {}
}
